import { Button } from "@progress/kendo-react-buttons";
import { Field, Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import FormTextBox from "../../commons/forms/FormTextBox";
import FormTextArea from "../../commons/forms/FormTextArea";
import { required } from "../../commons/forms/Validators";
import { useAddTacheMutation } from "../../redux/api/cache";

interface TaskFormProps {
    setOpenModalNewTask: (value: React.SetStateAction<boolean>) => void;
    div: number;
    dept: string;
    cat: string;
    four: string;
    tacheId: number;
    ptr: string;
    acheteur: string;
    activite: number;
    taches: string;
    approuveang: boolean | null;
    approuvefra: boolean | null;
}

export default function TaskForm(props: TaskFormProps) {
    const [addTache] = useAddTacheMutation();
    const handleSubmit = async (dataItem: any) => {
        props.setOpenModalNewTask(false);
        await addTache({
            div: props.div, dept: props.dept, cat: props.cat, four: props.four, tacheId: props.tacheId, prodNum: props.ptr,
            acht: props.acheteur, activite: props.activite, approuveang: props.approuveang, approuvefra: props.approuvefra, taches: props.taches, body: dataItem
        });
    };

    const descriptionValidator = (e: any) => required(e, 'Description');

    return <Form onSubmit={handleSubmit} render={(formRenderProps: FormRenderProps) => (
        <FormElement>
            <div style={{ display: 'flex', flexDirection: "column", rowGap: '2vh' }}>
                <Field id="description" name="description" component={FormTextBox} title={"Description"} label="Description" validator={descriptionValidator} />
                <Field id="instruction" name="instruction" component={FormTextArea} title={"Instruction"} label="Instruction" />
                <div style={{ display: 'flex', justifyContent: 'center', columnGap: '1vw' }}>
                    <Button className="blueButton" type="submit">Créer</Button>
                    <Button className="blueButton" onClick={() => props.setOpenModalNewTask(false)}>Annuler</Button></div>
            </div>
        </FormElement>)}></Form>;
}